<template>
    <div>
        <HeaderSection icon="fas fa-users" title="Administración de Usuarios">
            <template slot="buttons">
                <el-button
                        size="small"
                        type="success"
                        plain
                        icon="fas fa-file-excel"
                        @click="downloadExcel">
                    Exportar Usuarios
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        icon="fas fa-user-plus"
                        @click="$router.push('/administracion/usuarios/crear')">
                    Agregar usuario
                </el-button>
                <el-button
                        size="small"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="display: inline-block;margin-left: -10px;"
                        @size-change="handleSizeChange"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="parseInt(perPage)"
                        layout="sizes">
                </el-pagination>
            </el-col>
            <el-col :span="6">
                <el-input
                        style="width: 300px;"
                        placeholder="Buscar usuarios..."
                        prefix-icon="el-icon-search"
                        v-model="search"
                        clearable
                        @change="handleCurrentChange(1)"
                        @keyup.enter.native="handleCurrentChange(1)">
                </el-input>
            </el-col>
        </el-row>
        <br>
        <el-table :data="users" border stripe size="small">
            <el-table-column
                    prop="username"
                    label="Usuario"
                    sortable
                    width="125">
            </el-table-column>
            <el-table-column
                    prop="full_name"
                    width="250"
                    label="Nombre"
                    sortable>
            </el-table-column>
            <el-table-column
                    prop="office.representation_name"
                    width="550"
                    label="Representación"
                    sortable>
            </el-table-column>
            <el-table-column
                    prop="profile.name"
                    label="Perfil"
                    sortable>
            </el-table-column>

            <el-table-column label="Acciones" align="center" >
                <template slot-scope="scope">
                    <el-button-group width="350">

                        <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                            <el-button
                                    type="info"
                                    icon="fas fa-edit"
                                    size="small"
                                    @click="editUser(scope.row.crypt_id)">
                            </el-button>
                        </el-tooltip>

                        <el-tooltip v-if="scope.row.id != userId && scope.row.isActive"
                                    class="item" effect="dark"
                                    content="Desactivar"
                                    placement="top">
                            <el-button
                                    type="danger"
                                    size="small"
                                    icon="fas fa-trash"
                                    @click="deleteUser(scope.$index,scope.row)">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item"
                                    effect="dark"
                                    v-if="scope.row.id != userId && !scope.row.isActive"
                                    content="Activar"
                                    placement="top">
                            <el-button
                                    v-if="scope.row.id != userId"
                                    type="success"
                                    size="small"
                                    icon="fas fa-user-check"
                                    @click="deleteUser(scope.$index,scope.row)">
                            </el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>

            </el-table-column>
        </el-table>
        <br>
         <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, ->, prev, pager, next"
                :total="total"
                :page-size="parseInt(perPage)">
        </el-pagination>
    </div>
</template>

<script>
    import HeaderSection from '../../../partials/HeaderSection';

    export default {

        components: {
            HeaderSection,

        },

        computed: {
            userId() {
                return this.$store.state && this.$store.state.user && this.$store.state.user.id ? this.$store.state.user.id : null;
            },
        },


        data() {
            return {
                users: [],
                search: '',
                office: '',
                icon: 'el-icon-search',
                currentPage: 1,
                perPage: 10,
                total: 0,
                sortable: {
                    sort: 'ASC',
                    column: 'username'
                },
                 catalogs: {
                    offices: [],
                },
            }
        },

        created() {
            this.getUsers();

        },



        methods: {
            showLoading() {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: 'Cargando Datos...', status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            getUsers(page = 1) {
                let _this = this;
                let params = {
                    page: page,
                    search: this.search,
                    office: this.office,
                    perPage: this.perPage,
                    column: this.sortable.column,
                    sort: this.sortable.sort,
                };

                _this.icon = 'fa fa fa-spinner fa-spin';
                _this.showLoading();

                axios.get('/api/users', {params}).then(response => {
                    let users = response.data.users;

                    _this.users       = users.data;
                    _this.total       = users.total;
                    _this.currentPage = users.current_page;
                    _this.perPage     = users.per_page;

                    _this.hideLoading();
                    _this.icon = 'el-icon-search';
                }).catch(error => {
                    _this.hideLoading();
                    _this.icon = 'el-icon-search';

                    _this.$notify.error({
                        title: 'Error',
                        message: 'No se pudo completar la acción.'
                    });
                });
            },


            handleCurrentChange(page) {
                this.getUsers(page);
            },
            handleSizeChange(perPage) {
                this.perPage = perPage;
                this.getUsers();
            },

            editUser(id) {
                this.$router.push('/administracion/usuarios/editar/' + id);
            },
            deleteUser(index, row) {
                let _text = '';
                if(row.isActive == 1 || row.isActive == true){
                    _text = 'Desactivar'
                }else if(row.sActive == 0 || row.isActive == false){
                    _text = 'Activar';
                }
                this.$confirm('¿Desea ' + _text + ' este registro?', '', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {


                    axios.delete(`/api/users/${row.crypt_id}`).then(response =>
                       {
                        if (response.data.success) {
                            this.$notify({
                                title: 'Éxito',
                                message: response.data.message,
                                type: 'success'
                            });
                           this.getUsers();
                        }
                        else {
                            this.$notify({
                                title: 'Error',
                                message: response.data.message,
                                type: 'error'
                            });
                        }
                    }).catch(_ => {
                        this.$notify({
                            title: 'Error',
                            message: 'No se pudo completar la solicitud',
                            type: 'error'
                        });
                    });
                }).catch(e => {
                    console.log(e);
                    this.$notify({
                        title: 'Aviso: ',
                        message:'No se registró ningún cambio',
                        type: 'warning'
                    });
                });
            },


            downloadExcel() {
                let url = '/api/export-users';

                axios.get(url, {responseType: 'blob'}).then(response => {
                    this.$store.dispatch('loading/spinner', {}, {root: true});
                    this.$store.dispatch('loading/spinner', {}, {root: true});

                    let blob = new Blob([response.data]);
                    const linkUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = linkUrl;

                    link.setAttribute('download', 'Usuarios_MSE.xlsx');
                    document.body.appendChild(link);
                    link.click();

                }).catch(error => {
                    this.$store.dispatch('loading/spinner', {}, {root: true});

                    this.$notify({
                        title: 'Error',
                        message: 'No se pudo completar la acción',
                        type: 'error'
                    });
                    console.log("error", error);
                });
            },
        }

    }
</script>

<style>
</style>
